export * from './MarketingImage';
export * from './MarketingImage.styles';
